import WebApp from "@twa-dev/sdk";

/**
 * Works around the Telegram Android webview bug where minimizing and
 * re-expanding the Mini App leaves --tg-viewport-stable-height stale (small)
 * and the newly revealed area unpainted — only the top of the page stays
 * visible until the app is reopened.
 *
 * Keeps a --app-height CSS var in sync with the best available viewport
 * height and nudges the compositor into repainting after every change.
 */
export function initViewportFix() {
  const root = document.documentElement;

  const sync = () => {
    let tgH = 0;
    try {
      tgH = WebApp.viewportStableHeight || 0;
    } catch {
      /* not running inside Telegram */
    }
    const vvH = window.visualViewport?.height || 0;
    // Take the largest plausible height: when Telegram's var goes stale-small
    // after re-expand, visualViewport already reports the true size; when the
    // on-screen keyboard shrinks visualViewport, Telegram's var keeps the
    // layout stable.
    const h = Math.round(Math.max(tgH, vvH, window.innerHeight));
    if (h > 0) root.style.setProperty("--app-height", `${h}px`);

    // Force a composite repaint — Android WebView otherwise leaves the
    // re-revealed area blank until something moves.
    document.body.style.transform = "translateZ(0)";
    requestAnimationFrame(() => {
      document.body.style.transform = "";
    });
  };

  try {
    WebApp.onEvent("viewportChanged", sync);
  } catch {
    /* not running inside Telegram */
  }
  window.visualViewport?.addEventListener("resize", sync);
  window.addEventListener("resize", sync);
  window.addEventListener("orientationchange", sync);
  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      try {
        WebApp.expand();
      } catch {
        /* ignore */
      }
      sync();
      // Telegram reports the final height a moment after resume — re-sync
      setTimeout(sync, 250);
    }
  });

  sync();
}
